import { render, staticRenderFns } from "./SuperAdminRfid.vue?vue&type=template&id=1c4b9fb8"
import script from "./SuperAdminRfid.vue?vue&type=script&lang=js"
export * from "./SuperAdminRfid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports